import { CasePartnerHandoffInput } from '@/components/case-partner/components/CasePartnerHandoffInput';
import { useMatterJurisdiction } from '@/components/contexts/MatterJurisdictionContext';

interface BundlesCasePartnerComposerProps {
  matterGuid: string;
  existingBundleTitles?: string[];
}

export const BundlesCasePartnerComposer = ({
  matterGuid,
  existingBundleTitles = [],
}: BundlesCasePartnerComposerProps) => {
  const { ui_labels } = useMatterJurisdiction().jurisdiction;
  const singular = ui_labels.bundle_singular.toLowerCase();
  const namedBundleTitle = existingBundleTitles.find((title) => title.trim().length > 0);
  const hasExistingBundles = Boolean(namedBundleTitle);
  const prompts = namedBundleTitle
    ? [
        `Add the latest documents to “${namedBundleTitle}”`,
        `Create a hearing ${singular}`,
        `Put the witness statements in a ${singular}`,
      ]
    : [
        `Create a hearing ${singular}`,
        `Put the witness statements in a ${singular}`,
        `Create a trial ${singular} from the key documents`,
      ];

  return (
    <div className="mx-auto w-full max-w-2xl px-4">
      <div className="rounded-2xl border border-slate-200/80 bg-white px-8 py-10 shadow-sm shadow-slate-900/5 ring-1 ring-slate-900/4 sm:px-10 sm:py-12">
        <div className="mb-8 flex flex-col items-center text-center">
          <img src="/file-bundle.svg" alt="" className="mb-5 h-28 w-auto" />
          <h2 className="text-lg font-semibold tracking-tight text-slate-900">
            {hasExistingBundles
              ? `Create or refine a ${singular}`
              : `Let’s build your first ${singular}`}
          </h2>
        </div>
        <CasePartnerHandoffInput
          matterGuid={matterGuid}
          placeholder={
            hasExistingBundles
              ? `e.g. Add the expert reports to the hearing ${singular}`
              : `e.g. Hearing ${singular} of the witness statements and pleadings`
          }
          prompts={prompts}
        />
      </div>
    </div>
  );
};
